import { useEffect, useState, useContext,useRef } from "react";
import {Accordion,Card,ListGroup,Modal} from 'react-bootstrap';
import {BsFileEarmarkRuledFill,BsSearch,BsCashStack,BsCaretRight} from 'react-icons/bs';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { Dropdown } from 'react-bootstrap';
import $ from "jquery";
import ProfileCard from "../Profiles/ProfileCard";
import {
    useNavigate
  } from "react-router-dom";
import UserContext from "../../contexts/UserContext";

const Payment = ()=>{
    const navigate = useNavigate();
    const[sabeel, setSabeel] = useState(""); 
    const[hof, setHof] = useState(""); 
    const[name, setName] = useState(""); 
    const [message, setMessage] = useState('');
    const[profile, setProfile] = useState(null); 
    const[paymentMode, setPaymentMode] = useState(null); 
    const[showPayment, setShowPayment] = useState(false); 
    const[showTakhmeen, setShowTakhmeen] = useState(false); 
    const[totalTakhmeen, setTotalTakhmeen] = useState(null); 
    const[warning, setWarning] = useState(false); 
    const[prevYear,setPrevYear] = useState("0");
    const[currentYear,setCurrentYear] = useState("0");
    const[currentYearAmount,setCurrentYearAmount] = useState(0);
    const[nextYear,setNextYear] = useState("0");
    const [suggestions, setSuggestions] = useState([]); 
    const [clicked, setClicked] = useState(false); 
    const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);
    const inputRef = useRef(null);
    const {user,setUser} = useContext(UserContext);
    const [variant,setVariant] = useState(null);
    const [userPayments,setUserPayments] = useState(null);

    var curr = new Date();
    curr.setDate(curr.getDate());
    var date = curr.toISOString().substring(0,10);

    const handleClose = () => {setShowPayment(false);setShowTakhmeen(false);setPaymentMode(null);setCurrentYearAmount(0)};
    const handleShow = () => setShowPayment(true);

    async function getData(userId){
        await $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            if(response && response.user){
               setUser(response.user);
            }else{
              setUser(null)
              navigate("/login",{state: { message: response.message }})
            }
    
          },
          error: function(err){
              console.log("error")
              console.log(err)
          }
      })
      }

    useEffect(()=>{
        try{
        if(!user && localStorage.getItem('userSession')){
          getData(JSON.parse(localStorage.getItem('userSession')))
        }else{
          if(!user){
            navigate("/login")
          }
        }
      }catch(e){
        if(!user){
          navigate("/login")
        }
      }
      },[])

    useEffect(() => {
    // Make an AJAX call to fetch suggestions from the backend based on the inputValue
    // Replace the URL with your backend API endpoint
        const fetchData = async () => {
         await $.ajax({
            type:"GET",
            url:process.env.REACT_APP_API_URL+"/sabeelSuggestions?query="+name,
             success : function(response){
                setSuggestions(response);
      
            },
            error: function(err){
                console.error('Error fetching suggestions:', err);
                setSabeel("")
            }
         })
        }

        // Fetch data only if inputValue is not empty
        if (name && name.trim() !== '') {
            if(!clicked){
                fetchData();
            }
        } else {
        setSuggestions([]); // Clear suggestions if inputValue is empty
        }
    }, [name]);

    const searchBySabeel = async () => {
        setClicked(false);
        setMessage('');
        setPaymentMode(null);
        setShowPayment(false);
        setTotalTakhmeen(null)
        var sabeelObj = {type:"sabeel",value:sabeel}
        await $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/getUserByInfo",
            data:{sabeelObj},
            dataType:'json',
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
                if(response.message && response.message.includes("not found")){
                    setMessage(response.message)
                }else{
                    setProfile(response)
                    calculateTotalTakhmeen(response)
                    setUserPayments(response);
                    setHof("")
                    setSabeel('');
                }
            },
            error: function(err){
                console.log("error")
                console.log(err)
                setSabeel("")
            }
        })
    }

    const searchByHOF = async () => {
        setMessage('');
        setPaymentMode(null);
        setShowPayment(false);
        setTotalTakhmeen(null)
        var sabeelObj = {type:"hof",value:hof}
        await $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/getUserByInfo",
            data:{sabeelObj},
            dataType:'json',
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
                if(response.message && response.message.includes("not found")){
                    setMessage(response.message)
                }else{
                    setProfile(response)
                    calculateTotalTakhmeen(response)
                    setUserPayments(response);
                    setHof("")
                    setSabeel('');
                }
      
            },
            error: function(err){
                console.log("error")
                console.log(err)
                setHof("")
                setSabeel('');
            }
        })
    }

    const searchByName = async () => {
        setClicked(false)
        setMessage('');
        setPaymentMode(null);
        setShowPayment(false);
        setTotalTakhmeen(null)
        var sabeelObj = {type:"name",value:name}
        await $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/getUserByInfo",
            data:{sabeelObj},
            dataType:'json',
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
                if(response.message && response.message.includes("not found")){
                    setMessage(response.message)
                }else{
                    setProfile(response)
                    calculateTotalTakhmeen(response)
                    setUserPayments(response);
                    setName('');
                    setHof("")
                    setSabeel('');
                }
            },
            error: function(err){
                console.log("error")
                console.log(err)
                setName('');
                setHof("")
                setSabeel('');
            }
        })
    }

    const sendPaymentInfo = async (e) => {
        e.preventDefault();    
        if(e.target.refNumber){
            var paymentObj = {
                date: e.target.voucherDate.value,
                paymentType: e.target.paymentType.value,
                amount: e.target.amount.value,
                refNumber: e.target.refNumber.value,
                comments: e.target.comments.value,
                userInfo:{
                    name:profile.name,
                    sabeel: profile.sabeel,
                    hof: profile.hof
                }
            }
        }else{
            var paymentObj = {
                date: e.target.voucherDate.value,
                paymentType: e.target.paymentType.value,
                amount: e.target.amount.value,
                comments: e.target.comments.value,
                userInfo:{
                    name:profile.name,
                    sabeel: profile.sabeel,
                    hof: profile.hof
                }
            }
        }
        
        await $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/savePayment",
            data:{paymentObj,profile},
            dataType:'json',
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
                if(response.message.includes("success") && response.user){
                    setProfile(response.user);
                    calculateTotalTakhmeen(response.user);
                    setUserPayments(response.user);
                    if(user.name === response.user.name){
                        setUser(response.user)
                    }
                    setMessage(response.message);
                    setVariant("success")
                }else{
                    if(response.message){
                        setMessage(response.message);
                        setVariant("danger")
                    }
                }
            },
            error: function(err){
                console.log("error")
                console.log(err)
                setMessage("Something went wrong , please try again !")
                setVariant("danger")
            }
        })
        handleClose();
    }

    const changeAmount = (e) => {
        profile.takhmeen.map((takhmeen)=>{
            if(takhmeen.year.includes(e.target.value)){
                setCurrentYearAmount(takhmeen.amount)
            }
        })
    }

    const sendTakhmeenInfo = async (e) => {
        e.preventDefault();  
            var takhmeenObj = {
                date: e.target.takhmeenDate.value,
                year: e.target.year.value,
                amount: Number(e.target.amount.value),
                comments: e.target.comments.value
            }
        
        await $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/saveTakhmeen",
            data:{takhmeenObj,profile},
            dataType:'json',
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
                if(response.message.includes("success") && response.user){
                    setProfile(response.user);
                    calculateTotalTakhmeen(response.user);
                    setUserPayments(response.user);
                    if(user.name === response.user.name){
                        setUser(response.user)
                    }
                    setMessage(response.message);
                    setVariant("success")
                }else{
                    if(response.message){
                        setMessage(response.message);
                        setVariant("danger")
                    }
                }
            },
            error: function(err){
                console.log("error")
                console.log(err)
                setMessage("Something went wrong , please try again !")
                setVariant("danger")
            }
        })
        handleClose();
    }

    const getUserPayments = async ()=>{
        await $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/userPayments",
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            if(response.message){
                setUserPayments(null)
            }else{
              setUserPayments(response);
            }
    
          },
          error: function(err){
              console.log("error")
              console.log(err)
          }
      })
    }

    const getYears = async () => {
        let currYear = 0;
        await profile.takhmeen.map((takhmeen)=>{
            if(takhmeen.year.includes("-") && Number(takhmeen.year.split("-")[1])>Number(currYear)){
                setCurrentYear(takhmeen.year);
                if(takhmeen.year.split("-")[1] === "1445"){
                    setPrevYear("till1444")
                }else{
                    setPrevYear((Number(takhmeen.year.split("-")[0]) - 1).toString() + "-" + (Number(takhmeen.year.split("-")[1])-1).toString())
                }
                setNextYear((takhmeen.year.split("-")[1]).toString() + "-" + (Number(takhmeen.year.split("-")[1]) + 1).toString())
            }
        })
    }

    const calculateTotalTakhmeen=(profile)=>{
            let totalAmount = 0;
            profile.takhmeen.map((takhmeen)=>{
                totalAmount = takhmeen.amount + totalAmount;
            })
            setTotalTakhmeen(totalAmount)
        
    }

    const checkAmount = async (e) => {
        calculateTotalTakhmeen(profile);
        if(totalTakhmeen - profile.hubPaid<e.target.value){
            setWarning(true)
        }else{
            setWarning(false)
        }
    }

    const handleSuggestionClick = (suggestion) => {
        setName(suggestion);
        setClicked(true);
        setSuggestions([]); // Clear suggestions after selecting one
    };

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowDown' && selectedSuggestionIndex < suggestions.length - 1) {
          setSelectedSuggestionIndex(selectedSuggestionIndex + 1);
        } else if (e.key === 'ArrowUp' && selectedSuggestionIndex > 0) {
          setSelectedSuggestionIndex(selectedSuggestionIndex - 1);
        } else if (e.key === 'Enter' && selectedSuggestionIndex !== -1) {
          handleSuggestionClick(suggestions[selectedSuggestionIndex]);
        }
      };

      const UserPaymentCard = ({info}) => {
        const design = (
            <>
            <div className="minimal-payment-card">
                <div className="payment-details">
                    <div className="info-item">
                    <span className="info-label">Date:</span>
                    <span className="info-value">{info.date}</span>
                    </div>
                    <div className="info-item">
                    <span className="info-label">Type:</span>
                    <span className="info-value">{info.paymentType}</span>
                    </div>
                    <div className="info-item">
                    <span className="info-label">Ref #:</span>
                    <span className="info-value">{info.refNumber}</span>
                    </div>
                    <div className="info-item">
                    <span className="info-label">Amount:</span>
                    <span className="info-value">INR {info.amount}</span>
                    </div>
                    {
                        info.comments && info.comments.length>0?    
                        <div className="info-item">
                        <span className="info-label">Comments:</span>
                        <span className="info-value">{info.comments}</span>
                        </div>:
                        null
                    }
                </div>
            </div>
            </>
        )
        return design;
    }  

    const   PaymentHistory = () => {
        const design = (
            <>
            {
                userPayments && userPayments.payment && userPayments.payment.length>0?
                userPayments.payment.map((paymentInfo) => {
                    return <UserPaymentCard info={paymentInfo}/>
                })
                :
                <p className="p-3 pb-0" style={{color:'white'}}>No Payment Info ! </p>
            }
            </>
        )
        return design;
    }  

    const design = (
        <>
        <br/>
        <div className='m-2'>
        <Row>
            <Col>
                <div style={{width:'87%',display:'inline-block'}}>
                    <Form.Control style={{borderTopRightRadius:'0',borderBottomRightRadius:'0',borderColor:'white' }} type="text" placeholder="Search By Sabeel" value={sabeel} onChange={(e) => {setSabeel(e.target.value)}}/>
                </div>
            <Button style={{width:'12%',borderColor:'#dee2e6',borderTopLeftRadius:'0',borderBottomLeftRadius:'0',display:'inline-block',boxShadow:'none',marginTop:'-3px' }} type="button" onClick={searchBySabeel} >
                <BsSearch size={15} style={{color:'white!important'}} />
            </Button>
            </Col>
        </Row>
        <br/>
        <Row>
            <Col >
            <div style={{width:'87%',display:'inline-block'}}>  
                <Form.Control  style={{borderTopRightRadius:'0',borderBottomRightRadius:'0',borderColor:'white' }} type="text" placeholder="Search By HOF ITS" value={hof} onChange={(e) => {setHof(e.target.value)}}/>
            </div>
            <Button style={{width:'12%',borderColor:'#dee2e6',borderTopLeftRadius:'0',borderBottomLeftRadius:'0',display:'inline-block',boxShadow:'none',marginTop:'-3px' }} type="button" onClick={searchByHOF} >
                <BsSearch size={15} style={{color:'white!important'}} />
            </Button>
            </Col>
        </Row>
        <br/>
        <Row>
            <Col >
            <div style={{width:'87%',display:'inline-block'}}>
                <Form.Control  style={{borderTopRightRadius:'0',borderBottomRightRadius:'0',borderColor:'white' }}  type="text" placeholder="Search By Name" ref={inputRef} value={name} onChange={(e) => {setName(e.target.value)}} onKeyDown={handleKeyDown}/>  
                <Dropdown style={{ width: '100%' }} show={suggestions.length > 0} >

                <Dropdown.Menu>
                    {suggestions.map((suggestion, index) => (
                    <Dropdown.Item
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}
                    className={index === selectedSuggestionIndex ? 'active' : ''}
                  >
                    {suggestion}
                  </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
                </Dropdown>
            </div>
            <Button style={{width:'12%',borderColor:'#dee2e6',borderTopLeftRadius:'0',borderBottomLeftRadius:'0',display:'inline-block',boxShadow:'none',marginTop:'-3px' }} type="button" onClick={searchByName} >
                <BsSearch size={15} style={{color:'white!important'}} />
            </Button>
            </Col>
        </Row>
        </div>
        {message?<Alert key='danger' variant={variant}>{message} !</Alert>:null}

        {
            profile?
            <div>
            <ProfileCard user={profile}/>    
            <Card className="mt-3 mx-3">
                <Card.Header className='d-flex justify-content-between'>
                <div><BsFileEarmarkRuledFill className="svg-color"/> Takhmeen Details</div>
                </Card.Header>
                    {profile && profile.takhmeen && profile.takhmeen.length>0?
                    (
                        profile.takhmeen.map((currTakhmeen) => {
                            return (
                                    currTakhmeen.year==='till1444'?
                                    <ListGroup>
                                        <ListGroup.Item>Year : Till 1444H </ListGroup.Item>
                                        <ListGroup.Item>Hub Due : {currTakhmeen.amount}</ListGroup.Item>
                                    </ListGroup>:
                                    <ListGroup>
                                        <ListGroup.Item>Year : {currTakhmeen.year}  </ListGroup.Item>
                                        <ListGroup.Item>Takhmeen Amount : {currTakhmeen.amount}</ListGroup.Item>
                                    </ListGroup>
                                )
                        })
                    ):null
                    }
                <ListGroup>
                    <ListGroup.Item className="totalHub" style={{backgroundColor: '#402E32',fontWeight:'bold',color: 'white!important' }}>
                        Total Hub Due : {totalTakhmeen - profile.hubPaid}
                    </ListGroup.Item>
                </ListGroup>      
            </Card>
            <Accordion className="mt-3 mx-3">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>View Payment History</Accordion.Header>
                    <Accordion.Body className="paymentHistory">
                         <PaymentHistory/>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <br/>
            <div className="w-100 p-2 d-flex justify-content-around">
                <Button className="paymentBtn" type="button" onClick={()=>setShowPayment(true)}>
                    <span>Payment</span>
                    <BsCashStack/>
                </Button>
                <Button className="paymentBtn" type="button" onClick={()=>{getYears();setShowTakhmeen(true)}} >
                    <span>Takhmeen</span>
                    <BsCaretRight/>
                </Button>
            </div>
            </div>
            :null
        }

        <Modal show={showPayment} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {profile?profile.name:null}<br/>
          {profile?profile.sabeel:null}
          <br/>
          <br/>
          <Form id="paymentForm" onSubmit={sendPaymentInfo} >
            <Form.Group>
                <Form.Label>Date</Form.Label>
                <Form.Control type="date" placeholder="Date" name="voucherDate" defaultValue={date} required/>
            </Form.Group>
            <Form.Group className="mb-3">
                  <Form.Label>Payment type</Form.Label>
                  <Form.Select name="paymentType" onChange={(e) => {setPaymentMode(e.target.value)}} aria-label="Default select example" required>
                    <option>Select Payment Mode</option>
                    <option value="cash" >Cash</option>
                    <option value="cheque">Cheque</option>
                    <option value="online">Online transfer</option>
                  </Form.Select>
            </Form.Group>

            {
                paymentMode==="cash"?
                (<Form.Group>
                <Form.Label>Amount</Form.Label>
                <Form.Control name="amount" type="number" placeholder="Amount" onChange={checkAmount} required/>
                {warning?<p style={{color:'red'}}>Amount entered is greater than due amount.It will result in negative balance.</p>:null}
                </Form.Group>):
                paymentMode==="cheque"?
                (
                <>
                <Form.Group>
                <Form.Label>Amount</Form.Label>
                <Form.Control name="amount" type="number" placeholder="Amount" onChange={checkAmount} required/>
                </Form.Group>
                {warning?<p style={{color:'red'}}>Amount entered is greater than due amount.It will result in negative balance.</p>:null}
                <br/>
                <Form.Group>
                <Form.Label>Reference Number</Form.Label>
                <Form.Control name="refNumber" type="text" placeholder="Reference Number" />
                </Form.Group>
                </>
                ):
                paymentMode==="online"?
                (
                <>
                <Form.Group>
                <Form.Label>Amount</Form.Label>
                <Form.Control name="amount" type="number" placeholder="Amount" onChange={checkAmount} required/>
                {warning?<p style={{color:'red'}}>Amount entered is greater than due amount.It will result in negative balance.</p>:null}
                </Form.Group>
                <br/>
                <Form.Group>
                <Form.Label>Reference Number</Form.Label>
                <Form.Control name="refNumber" type="text" placeholder="Reference Number" />
                </Form.Group>
                </>
                ):null

            }
            <br/>    
            <Form.Group>
                <Form.Control name="comments" type="textarea" placeholder="Comments" />
            </Form.Group>
            <br/>    
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
          </Modal.Body>
          </Modal>


        <Modal show={showTakhmeen} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Takhmeen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {profile?profile.name:null}<br/>
          {profile?profile.sabeel:null}
          <br/>
          <br/>
          <Form id="takhmeenForm" onSubmit={sendTakhmeenInfo} >
            <Form.Group>
                <Form.Label>Date</Form.Label>
                <Form.Control type="date" placeholder="takhmeenDate" name="takhmeenDate" defaultValue={date} required/>
            </Form.Group>
            <Form.Group className="mb-3">
                  <Form.Label>Year</Form.Label>
                  {profile && profile.takhmeen && profile.takhmeen.length>0?
                  <Form.Select name="year" onChange={changeAmount} aria-label="Default select example" required>
                    <option>Select Year</option>
                    <option value={prevYear} >{prevYear}</option>
                    <option value={currentYear}>{currentYear}</option>
                    <option value={nextYear}>{nextYear}</option>
                  </Form.Select>:
                  <Form.Control type="text" placeholder="Enter Year (Format: 1444-1445)" name="year" onChange={changeAmount} />}
            </Form.Group>
            <br/>
            <Form.Group>
                <Form.Label>Amount</Form.Label>
                <Form.Control type="number" placeholder="Amount" name="amount" value={currentYearAmount} onChange={(e)=>setCurrentYearAmount(e.target.value)} required/>
            </Form.Group>
            <br/>    
            <Form.Group>
                <Form.Control name="comments" type="textarea" placeholder="Comments" />
            </Form.Group>
            <br/>    
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
          </Modal.Body>
          </Modal>
        </>
    ) 
    return design;
}

export default Payment;